import { useCurrentUser } from './useCurrentUser';
import { storage } from '@/lib/storage';

export interface RoleContext {
  isBranchIncharge: boolean;
  isZoneManager: boolean;
  isTelecaller: boolean;
  branchCode: string;
  zoneCode: string;
  stateCode: string;
  cityCode: string;
  role: string;
}

export function useRoleContext(): RoleContext {
  const userDetails = useCurrentUser();
  const userData = storage.getUserData();

  const rawRole =
    (userDetails as any)?.role ||
    userData?.role ||
    userData?.user?.role ||
    '';
  const role = rawRole.toLowerCase().replace(/[\s_]+/g, '');

  const isBranchIncharge = role === 'branchincharge';
  const isZoneManager    = role === 'zonemanager';
  const isTelecaller     = role === 'telecaller';

  const branchCode =
    ((userDetails as any)?.branch_code || userData?.branch_code || '') as string;
  const zoneCode =
    ((userDetails as any)?.zone_code || userData?.zone_code || '') as string;
  const stateCode =
    ((userDetails as any)?.state_code || userData?.state_code || '') as string;
  const cityCode =
    ((userDetails as any)?.city_code || userData?.city_code || '') as string;

  return { isBranchIncharge, isZoneManager, isTelecaller, branchCode, zoneCode, stateCode, cityCode, role };
}
